---
en:
  activemodel:
    attributes:
      green_months_bulk_update_form:
        from_month: From (month)
        realized_price: Price (NOK/MWh)
        to_month: To (month)
  errors:
    messages:
      from_month_should_not_be_after_to_month: From (month) should not be after To (month)
  green_months:
    actions: Actions
    available_years: Available Years
    header: Realized %{type} for %{power_plant}
    realized_price: Price [NOK] per MWh
    volume: Volume [MWh]
  green_months_bulk_update_form:
    header: Set %{type} prices for a time range
  messages:
    bulk_update_executed: Bulk update executed
  update_all_green_months:
    header: Realized prices for %{power_plant} %{year}
